import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import UserContext from "../../contexts/UserContext";
import HrCertification from "../../components/hotelRepresentative/HrCertification";
import { BrandResource } from "../../components/common";
import _ from "lodash";

const PhotoshootRequest = (props) => {
  const { userData } = useContext(UserContext);
  /* Getting List of Photographers */
  const [photographers, setPhotographers] = useState([]);
  /* Recce enabled state */
  const [recceEnabled, setRecceEnabled] = useState(false);
  const [photoshootType, setPhotoshootType] = useState("GEN");

  const [selectedCountry, setSelectedCountry] = useState(null);

  /* Getting list of countries */
  useEffect(() => {
    axios
      .get(
        Utils.apiUrl(
          "hr/photographers",
          "limit=99999&fields=id,name,country_id",
        ),
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          setPhotographers(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Scroll to top function on submit of form */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* Err list for validation of form */
  const [submitted, setSubmitted] = useState(false);
  const [succ, setSucc] = useState({ status: false, message: "" });
  const [err, setErr] = useState([]);
  const [pgID, setPGID] = useState(0);
  const [countries, setCountries] = useState([]);

  /* Getting list of countries */
  useEffect(() => {
    axios
      .get(Utils.apiUrl("countries?limit=1000"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setCountries(res.data.data);
          setSelectedCountry(
            res.data.data.find((c) => c.id === userData.hotel_country_id),
          );
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Handling change of country selection */
  const handleCountryChange = (e) => {
    const countryName = e.target.value;

    const countryObj = countries.find((c) => c.name === countryName);
    setSelectedCountry(countryObj);
  };
  /* Submitting Photoshoot Request  */
  const submitPhotoshootRequest = (e) => {
    scrollToTop();
    const frm = e.currentTarget;
    e.preventDefault();
    const isGeneralPhotoshoot = frm.type.value === "GEN";

    const formData = new FormData();
    //formData.append('title', frm.title.value);
    formData.append("hotel_id", Utils.getUserData().hotel_id);
    formData.append("date_from", frm.date_from.value);

    formData.append("type", frm.type.value);
    formData.append(
      "lifestyle",
      frm.type.value === "GEN" ? frm.lifestyle.value : 0,
    );
    formData.append(
      "architectural",
      isGeneralPhotoshoot ? frm.architectural.value : 0,
    );
    formData.append(
      "loc_expiry_date",
      isGeneralPhotoshoot ? "" : frm.loc_expiry_date.value,
    );
    formData.append("hotel_type", frm.hotel_type.value);
    formData.append(
      "recce_start",
      isGeneralPhotoshoot ? frm.recce_start.value : "",
    );
    formData.append(
      "recce_end",
      isGeneralPhotoshoot ? frm.recce_end.value : "",
    );
    formData.append("notes", frm.notes.value);
    formData.append("photographer_id", isGeneralPhotoshoot ? pgID : 0);
    if (isGeneralPhotoshoot) {
      formData.append("date_to", frm.date_to.value);
      formData.append("country", frm.country.value);
      formData.append("budget", frm.budget.value + "-" + frm.country.value);
    } else {
      formData.append("ph_name", frm.ph_name.value);
    }

    /*
    // Add attachments
    if (isGeneralPhotoshoot) {
      const files = frm.attachments.files;
      for (let i = 0; i < files.length; i++) {
        formData.append("attachments", files[i]);
      }
    }*/

    let err1 = [];
    //if(frm.title.value == '') {err1.push('Enter Photoshoot Title');}
    if (frm.date_from.value == "") {
      err1.push("Select Photoshoot Date (From)");
    }
    if (isGeneralPhotoshoot && frm.date_to.value == "") {
      err1.push("Select Photoshoot Date (To)");
    }
    if (!isGeneralPhotoshoot && frm.loc_expiry_date.value == "") {
      err1.push("Select LOC Expiry Date");
    }
    if (frm.hotel_type.value == "") {
      err1.push("Select Type of Hotel");
    }

    if (!isGeneralPhotoshoot && frm.ph_name.value == "") {
      if (photoshootType === "REN")
        err1.push("Enter Architect / ID Company Name");
      else if (photoshootType === "LA") err1.push("Enter Photographer Name");
    }
    /* if(frm.notes.value == '') {err1.push('Enter Notes');} */
    // Only require photographer if not hotel owner
    const isHotelOwner = userData?.isHO || false;
    if (!isHotelOwner && isGeneralPhotoshoot && pgID == 0) {
      err1.push("Select Photographer1");
    } else if (!isGeneralPhotoshoot || isHotelOwner) {
      // Remove 'Select Photographer' error if switching away from GEN or user is HO
      setErr((prevErr) => prevErr.filter((e) => e !== "Select Photographer2"));
    }

    // GEN type: Architectural and Lifestyle must be numbers, required, min 0
    if (isGeneralPhotoshoot) {
      const architecturalVal = frm.architectural.value;
      const lifestyleVal = frm.lifestyle.value;
      if (
        architecturalVal === "" ||
        isNaN(architecturalVal) ||
        Number(architecturalVal) < 0
      ) {
        err1.push("Enter Architectural count (minimum 0)");
      }
      if (
        lifestyleVal === "" ||
        isNaN(lifestyleVal) ||
        Number(lifestyleVal) < 0
      ) {
        err1.push("Enter Lifestyle count (minimum 0)");
      }
    }

    setErr(err1);
    if (err1.length == 0) {
      axios
        .post(Utils.apiUrl(`hr/phrequest`), formData, Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setSubmitted(true);
            /* setSucc({status: true, message: res.data.message});
            setTimeout(function() {
                window.location.reload();
            }, 2000); */
          } else {
            setSucc({ status: false, message: "" });
            err1.push(res.data.message);
            setErr(err1);
          }
          //console.log(frmMess);
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
  };

  const [guidelineDetails, setGuidelineDetails] = useState([]);
  const [hotelDetails, setHotelDetails] = useState([]);
  /* Getting HR Hotel Details */
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`hr/brandDetail`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          /* Getting Hotel Details */
          setHotelDetails(res.data);
          // Set selectedCountry for Hotel Owner using hotel country_id
          if (
            userData?.role === "HO" &&
            res.data &&
            res.data.country_id &&
            countries.length > 0
          ) {
            const countryObj = countries.find(
              (c) => c.id === res.data.country_id,
            );
            if (countryObj) setSelectedCountry(countryObj);
          }
          axios
            .get(
              Utils.apiUrl(`brand/${res.data.brand.brand_id}`),
              Utils.apiHeaders(),
            )
            .then((res) => {
              var udata = Utils.getUserData();
              if (res.status == 200) {
                setGuidelineDetails(res.data);
              }
            })
            .catch((err) => {
              //callback(false, err.message);
            });
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, [countries, userData]);

  const getPhotographersList = () => {
    const hotelCountryId = Number(hotelDetails?.brand?.country_id || 0);

    let phdata1 = photographers
      .filter((ph) => Number(ph.country_id) === hotelCountryId)
      .sort((a, b) => a.name.localeCompare(b.name));
    let phdata2 = photographers
      .filter((ph) => Number(ph.country_id) !== hotelCountryId)
      .sort((a, b) => a.name.localeCompare(b.name));

    console.log("photographers", hotelCountryId, phdata1, phdata2);

    return [...phdata1, ...phdata2].map((photographer) => ({
      id: photographer.id,
      name: photographer.name,
    }));
  };

  const guidlineFile = () => {
    if (photoshootType === "REN") {
      return {
        href: "https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/hotel/HWS%20Rendering%20Guidance%20Oct26.pdf",
        name: "HWS Rendering Guidance Oct26.pdf",
      };
    } else {
      return {
        href: "https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/hotel/HWS%20Rendering%20Guidance%20Oct26.pdf",
        name: "HWS Rendering Guidance Oct26.pdf",
      };
    }
  };

  return (
    <>
      <div className="container mx-auto p-8">
        <h2 className="text-2xl font-bold text-center mb-6">
          Photoshoot Request Form
        </h2>
        {/* When form is not submitted */}
        {submitted == false && (
          <>
            {/* For Success on submission */}
            {/* {succ.status == true && 
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto" role="alert">
                <p><strong>{succ.message}</strong></p>
            </div>
            } */}

            {/* For Error on submission */}
            {err.length > 0 && (
              <div
                className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 text-sm rounded relative mb-4
             w-full max-w-2xl mx-auto"
                role="alert"
              >
                <ul>
                  {err.map((item, index) => (
                    <li key={index} className="block">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* When form is not submitted */}
            <>
              <form
                method="get"
                action="hotel-representative-photoshoot-requirement-form-confirmation.html"
                className="bg-white p-8 rounded-lg shadow-md w-full max-w-2xl mx-auto"
                onSubmit={submitPhotoshootRequest}
              >
                <h3 className="text-lg font-medium mb-4">
                  {Utils.getUserData().hotel_name}
                </h3>
                {/* <div className="mb-4">
                    <label for="title" className="block text-gray-700 text-sm font-bold mb-2">Photoshoot Title:</label>
                    <input type="text" id="title" name="title" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Photoshoot Title"
                        value={`${hotelDetails.marsha}_${guidelineDetails.abbr}_${hotelDetails.name}`} />
                </div> */}

                <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                  <div>
                    <label
                      for="type"
                      className="block text-gray-700 text-sm font-bold mb-2 flex justify-between"
                    >
                      <div>Type of Assets:</div>
                      {photoshootType === "GEN" && <div>No. of Photos:</div>}
                    </label>
                    <select
                      name="type"
                      id="type"
                      value={photoshootType}
                      onChange={(event) =>
                        setPhotoshootType(event.target.value)
                      }
                      className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                    >
                      {Object.entries(Utils.getPhotoshootTypes()).map(
                        ([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        ),
                      )}
                    </select>
                  </div>

                  {photoshootType === "GEN" && (
                    <div>
                      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        <div className="form-group">
                          <label for="architectural" className="form-label">
                            Architectural
                          </label>
                          <input
                            name="architectural"
                            id="architectural"
                            type="number"
                            min={0}
                            defaultValue={0}
                            className="form-input"
                          />
                        </div>
                        <div className="form-group">
                          <label for="lifestyle" className="form-label">
                            Lifestyle
                          </label>
                          <input
                            name="lifestyle"
                            id="lifestyle"
                            type="number"
                            min={0}
                            defaultValue={0}
                            className="form-input"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {photoshootType !== "GEN" && (
                    <div>
                      <label
                        for="loc_expiry_date"
                        className="block text-gray-700 text-sm font-bold mb-2"
                      >
                        LOC Expiry Date:
                        <i
                          className="fas fa-info-circle text-yellow-500 cursor-pointer ml-2"
                          title="LOC expiry date should accommodate the time required to replace renderings with actual brand photography."
                        ></i>
                      </label>
                      <input
                        type="date"
                        id="loc_expiry_date"
                        name="loc_expiry_date"
                        required
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </div>
                  )}
                </div>

                <div className="mb-4 flex space-x-4">
                  <div className="w-1/2">
                    <label
                      for="date_from"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      {photoshootType === "GEN" && (
                        <>Photoshoot Date (From): </>
                      )}
                      {photoshootType !== "GEN" && (
                        <>
                          {photoshootType === "REN" && (
                            <>Rendering Creation Date:</>
                          )}
                          {photoshootType === "LA" && <>Photoshoot Date:</>}
                        </>
                      )}
                    </label>
                    <input
                      type="date"
                      id="date_from"
                      name="date_from"
                      required
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                  {photoshootType === "GEN" && (
                    <div className="w-1/2">
                      <label
                        for="date_to"
                        className="block text-gray-700 text-sm font-bold mb-2"
                      >
                        Photoshoot Date (To):
                      </label>
                      <input
                        type="date"
                        id="date_to"
                        name="date_to"
                        required
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </div>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Type of Hotel:
                  </label>
                  <div className="">
                    {photoshootType !== "LA" && (
                      <label className="block items-center">
                        <input
                          type="radio"
                          name="hotel_type"
                          id="hotel_type_new"
                          value="new"
                          className="form-radio"
                          onChange={(e) => setRecceEnabled(true)}
                        />
                        <span className="ml-2 mb-2 inline-block">
                          Pre-opening/New Build{" "}
                          {photoshootType === "GEN" && (
                            <span className="recce-tag">
                              Recce submission required
                            </span>
                          )}
                        </span>
                      </label>
                    )}
                    <label className="block items-center">
                      <input
                        type="radio"
                        name="hotel_type"
                        id="hotel_type_established"
                        value="established"
                        className="form-radio"
                        onChange={(e) => setRecceEnabled(true)}
                      />
                      <span className="ml-2 mb-2 inline-block">
                        External Conversion{" "}
                        {photoshootType === "GEN" && (
                          <span className="recce-tag">
                            Recce submission required
                          </span>
                        )}{" "}
                        <i
                          className="fas fa-info-circle text-yellow-500 cursor-pointer"
                          title="External brand conversion to Marriott brand"
                        ></i>
                      </span>
                    </label>
                    <label className="block items-center">
                      <input
                        type="radio"
                        name="hotel_type"
                        id="hotel_type_converted"
                        value="converted"
                        className="form-radio"
                        onChange={(e) => setRecceEnabled(false)}
                      />
                      <span className="ml-2 mb-2 inline-block">
                        Internal Conversion{" "}
                        {photoshootType === "GEN" && (
                          <span className="recce-tag">Recce not needed</span>
                        )}
                        <i
                          className="fas fa-info-circle text-yellow-500 cursor-pointer"
                          title="One Marriott brand converting to another Marriott brand"
                        ></i>
                      </span>
                    </label>
                    {photoshootType !== "LA" && (
                      <label className="block items-center">
                        <input
                          type="radio"
                          name="hotel_type"
                          id="hotel_type_refresh"
                          value="refresh"
                          className="form-radio"
                          onChange={(e) => setRecceEnabled(false)}
                        />
                        <span className="ml-2 mb-2 inline-block">
                          Renovation/Refresh/Update{" "}
                          {photoshootType === "GEN" && (
                            <span className="recce-tag">Recce Not Needed</span>
                          )}
                          <i
                            className="fas fa-info-circle text-yellow-500 cursor-pointer"
                            title="Established and Operating hotel"
                          ></i>
                        </span>
                      </label>
                    )}
                  </div>
                </div>
                {photoshootType === "GEN" && (
                  <div className="reccedetails">
                    <div className="mb-4 flex space-x-4">
                      <div className="w-1/2">
                        <label
                          for="recce_start"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Recce Date (From):
                        </label>
                        <input
                          type="date"
                          id="recce_start"
                          name="recce_start"
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          disabled={!recceEnabled}
                        />
                      </div>
                      <div className="w-1/2">
                        <label
                          for="recce_end"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Recce Date (To):
                        </label>
                        <input
                          type="date"
                          id="recce_end"
                          name="recce_end"
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          disabled={!recceEnabled}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {photoshootType !== "GEN" && (
                  <div className="mb-4">
                    <label
                      for="ph_name"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      {photoshootType === "REN" && (
                        <>Architect / ID Company Name:</>
                      )}
                      {photoshootType === "LA" && <>Photographer Name:</>}
                    </label>
                    <input
                      type="text"
                      id="ph_name"
                      name="ph_name"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </div>
                )}
                <div className="mb-4">
                  <label
                    for="notes"
                    className="block text-gray-700 text-sm font-bold mb-2"
                  >
                    Notes:
                  </label>
                  <textarea
                    name="notes"
                    id="notes"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  ></textarea>
                </div>
                {photoshootType === "GEN" && !Utils.isHotelOwner() && (
                  <div className="mb-4">
                    <label
                      for="photographer_id"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Assign Photographer:
                    </label>
                    <div className="chosenwrap">
                      <ReactSearchAutocomplete
                        items={getPhotographersList()}
                        onSelect={({ id }) => setPGID(id)}
                        onClear={() => setPGID("")}
                        placeholder="Select Photographer"
                        fuseOptions={{ keys: ["name"] }}
                        resultStringKeyName="name"
                      />
                    </div>
                  </div>
                )}
                {false && photoshootType === "GEN" && (
                  <div className="mb-4">
                    <label
                      for="attachments"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Shot-list files:
                    </label>
                    <input
                      type="file"
                      id="attachments"
                      name="attachments"
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      multiple="multiple"
                    />
                  </div>
                )}
                {photoshootType === "GEN" && (
                  <div className="mb-6">
                    <label
                      htmlFor="budget"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Amount paid to photographer for photoshoot (local currency
                      in numbers):
                    </label>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Country Dropdown */}
                      <select
                        id="country"
                        name="country"
                        required
                        value={selectedCountry?.name || ""}
                        onChange={handleCountryChange}
                        className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none"
                      >
                        <option value="">Select Country</option>

                        {countries.map((country) => (
                          <option
                            key={country.id}
                            value={country.name}
                            selected={selectedCountry?.id === country.id}
                          >
                            {country.name}
                          </option>
                        ))}
                      </select>
                      {/* Amount with Currency Prefix */}
                      <div className="flex items-center border rounded overflow-hidden shadow">
                        {/* Currency Prefix */}
                        {selectedCountry && (
                          <span className="px-3 bg-gray-100 text-gray-700 font-semibold min-w-[100px] text-center flex items-center justify-center h-full leading-none whitespace-nowrap">
                            {selectedCountry?.currency_code} (
                            {selectedCountry?.currency_symbol || "--"})
                          </span>
                        )}

                        {/* Amount Input */}
                        <input
                          type="number"
                          id="budget"
                          name="budget"
                          required
                          className="w-full py-2 px-3 focus:outline-none"
                          placeholder="Enter amount"
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-center">
                  <button
                    type="submit"
                    className="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </>
          </>
        )}

        {/* When form is submitted */}
        {submitted == true && (
          <>
            <div className="confirmation-message text-center">
              <p className="text-xl text-green-600 mb-4">
                Photoshoot request has been submitted successfully.
              </p>
            </div>
            <div className="block bg-white shadow-md rounded-lg p-6 mb-6">
              {photoshootType === "GEN" && (
                <>
                  <h2 className="text-xl font-bold mb-4">
                    {guidelineDetails.name}
                  </h2>
                  <div
                    className="mb-6"
                    dangerouslySetInnerHTML={{
                      __html: guidelineDetails.hr_guidelines,
                    }}
                  ></div>
                  <BrandResource brand={guidelineDetails.name} />
                </>
              )}
              {photoshootType !== "GEN" && (
                <>
                  <a
                    href={guidlineFile().href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full flex flex-col items-center"
                  >
                    <i
                      className={`fas fa-file-pdf text-red-600 text-3xl mb-2`}
                    ></i>
                    <span
                      className="w-full text-center break-words whitespace-normal leading-snug text-blue-500"
                      title={guidlineFile().name}
                    >
                      {guidlineFile().name}
                    </span>
                  </a>
                </>
              )}
              <div className="mt-6 text-xl bg-yellow-100 rounded p-2">
                Your photoshoot request has been processed successfully,
                continue to your{" "}
                <a href="/dashboard" className="text-blue-600 font-bold">
                  Dashboard
                </a>
                .
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PhotoshootRequest;
